import { datadogRum } from '@datadog/browser-rum';
import type { User } from '@/lib/types';

declare const __APP_VERSION__: string;

const ENABLED_ENVS = new Set(['production']);

function resolveSessionReplaySampleRate(env: string): number {
  const override = import.meta.env.VITE_DD_SESSION_REPLAY_SAMPLE_RATE;
  if (override !== undefined && override !== '') {
    const parsed = Number(override);
    if (Number.isFinite(parsed) && parsed >= 0 && parsed <= 100) return parsed;
  }
  return env === 'production' ? 20 : 100;
}

export function initDatadogRum() {
  const applicationId = import.meta.env.VITE_DD_APPLICATION_ID;
  const clientToken = import.meta.env.VITE_DD_CLIENT_TOKEN;
  const env = import.meta.env.VITE_APP_ENV;
  const apiUrl = import.meta.env.VITE_API_URL;

  if (!applicationId || !clientToken || !ENABLED_ENVS.has(env)) return;

  const sessionReplaySampleRate = resolveSessionReplaySampleRate(env);

  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'dzone-frontend',
    env,
    version: __APP_VERSION__,
    sessionSampleRate: 100,
    sessionReplaySampleRate,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackViewsManually: true,
    defaultPrivacyLevel: 'mask-user-input',
    silentMultipleInit: true,
    allowedTracingUrls: [{ match: apiUrl, propagatorTypes: ['datadog', 'tracecontext'] }],
  });

  datadogRum.setGlobalContextProperty('env', env);
}

export function setRumUser(user: User) {
  datadogRum.setUser({
    id: user.id,
    email: user.email,
    name: user.fullName,
    tenantId: user.tenantId,
    tenantName: user.tenantName,
    roles: user.roles,
  });
}

export function clearRumUser() {
  datadogRum.clearUser();
}

export function trackRumView(name: string) {
  datadogRum.startView({ name });
}
